import { Button } from '@design-system/button';
import { DialogBody, DialogFooter, DialogHeader } from '@design-system/dialog';
import { DocumentDownload, DocumentText, MoneyTick } from 'iconsax-react';
import type { FC } from 'react';

const statusColors = {
  UPCOMING: {
    color: '#FD8100',
    backgroundColor: 'bg-secondary-50',
  },
  PAID: {
    color: '#0E9F6E',
    backgroundColor: 'bg-green-50',
  },
  CANCELED: {
    color: '#F05252',
    backgroundColor: 'bg-red-50',
  },
  FAILED: {
    color: '#F05252',
    backgroundColor: 'bg-red-50',
  },
};

const InvoiceDialog: FC<{
  status: 'UPCOMING' | 'PAID' | 'CANCELED' | 'FAILED';
}> = ({ status }) => {
  return (
    <>
      <DialogHeader>Invoice</DialogHeader>
      <DialogBody>
        <div className='flex items-center gap-2 mb-10'>
          <div
            className={`${statusColors[status].backgroundColor} rounded-full h-12 w-12 flex items-center justify-center`}
          >
            <MoneyTick
              size='24'
              color={statusColors[status].color}
            />
          </div>
          <div className='flex flex-col'>
            <p className='text-gray-900 font-medium text-base'>
              Advanced Plan (Yearly)
            </p>
            <p className='text-gray-800 font-normal text-sm'>
              Invoice date May 16, 2025
            </p>
          </div>
        </div>
        <div className='grid grid-cols-2 gap-y-8 mb-10'>
          <div className='flex flex-col gap-1'>
            <p className='text-gray-600 text-sm'>Invoice Number</p>
            <p className='text-primary-1000 font-medium text-base'>
              8239675892168956
            </p>
          </div>
          <div className='flex flex-col gap-1'>
            <p className='text-gray-600 text-sm'>Due Date</p>
            <p className='text-gray-900 font-medium text-base'>May 16, 2025</p>
          </div>
          <div className='flex flex-col gap-1'>
            <p className='text-gray-600 text-sm'>Status</p>
            <p
              className='text-primary-1000 font-medium text-base capitalize'
              style={{ color: statusColors[status].color }}
            >
              {status.toLocaleLowerCase()}
            </p>
          </div>
          <div className='flex flex-col gap-1'>
            <p className='text-gray-600 text-sm'>Payment Method</p>
            <p className='text-primary-1000 font-medium text-base'>
              Visa ••••2876
            </p>
          </div>
        </div>
        <div className='border border-primary-200 rounded-xl px-4 py-3'>
          <div className='flex justify-between items-center mb-3'>
            <p className='text-gray-800 font-medium text-base'>Subtotal</p>
            <p className='text-gray-900 font-medium text-base'>$3499</p>
          </div>
          <div className='flex justify-between items-center mb-3'>
            <p className='text-gray-800 font-medium text-base'>Discount</p>
            <p className='text-gray-900 font-medium text-base'>20%</p>
          </div>
          <div className='flex justify-between items-center mb-3 border-b border-primary-200 pb-3'>
            <p className='text-gray-800 font-medium text-base'>Tax</p>
            <p className='text-gray-900 font-medium text-base'>14%</p>
          </div>
          <div className='flex justify-between items-center'>
            <p className='text-gray-800 font-medium text-base'>Total</p>
            <p className='text-gray-900 font-medium text-base'>$3499</p>
          </div>
        </div>
      </DialogBody>
      <DialogFooter>
        <Button
          variant='primaryOutline'
          className='w-1/2'
        >
          <DocumentText />
          View Invoice
        </Button>
        <Button
          variant='primaryOutline'
          className='w-1/2'
        >
          <DocumentDownload />
          Download Invoice
        </Button>
      </DialogFooter>
    </>
  );
};

export default InvoiceDialog;
